import { lazy, Suspense, useEffect, useState } from 'react'
import { LoaderCircle, ShoppingCart } from 'lucide-react'
import { useFeatureDispatch, useFeatureSelector } from '@/platform/state/hooks'
import { hasPermission } from '@/platform/authorization/permissions'
import { injectFeatureReducer } from '@/platform/state/reducerRegistry'
import type { CartsState } from '../store/cartsSlice'

const PersonalCartDrawer = lazy(() => import('./PersonalCartDrawer'))

export function PersonalCartButton() {
  const [open, setOpen] = useState(false)
  const [openedOnce, setOpenedOnce] = useState(false)
  const dispatch = useFeatureDispatch()
  const userId = useFeatureSelector((state) => state.session.user?.id)
  const authorization = useFeatureSelector((state) => state.session.authorization)
  const cartState = useFeatureSelector((state) => (state as unknown as { ordersCarts?: CartsState }).ordersCarts)
  const canUseCart = Boolean(userId && hasPermission(authorization, 'orders'))

  useEffect(() => {
    if (!canUseCart) return
    let cancelled = false
    void import('../store/cartsSlice').then(({ cartsReducer, fetchMyCart }) => {
      injectFeatureReducer('ordersCarts', cartsReducer)
      if (!cancelled) void dispatch(fetchMyCart({ force: true }))
    })
    return () => { cancelled = true }
  }, [canUseCart, dispatch, userId])

  if (!canUseCart || !userId) return null

  const cartUserId = cartState?.personalCart?.user_id
  const count = String(cartUserId) === String(userId)
    ? cartState?.personalCart?.items.reduce((total, item) => total + Number(item.quantity || 0), 0) ?? 0
    : 0

  return <>
    <button type="button" onClick={() => { setOpenedOnce(true); setOpen((value) => !value) }} aria-label={`Mở giỏ hàng${count ? `, ${count} sản phẩm` : ''}`} aria-expanded={open} title="Giỏ hàng" className="relative z-10 grid h-10 w-10 shrink-0 place-items-center rounded-lg border border-sky-200 bg-sky-50 text-sky-700 transition hover:border-sky-300 hover:bg-sky-100">
      <ShoppingCart size={19} />
      {count > 0 && <span className="absolute -right-1.5 -top-1.5 z-20 grid h-5 min-w-5 place-items-center rounded-full border-2 border-white bg-orange-500 px-1 text-[10px] font-bold leading-none text-white shadow-sm">{count > 99 ? '99+' : count}</span>}
    </button>
    {openedOnce && <Suspense fallback={open ? <span className="fixed inset-0 z-[150] grid place-items-center bg-slate-950/25"><LoaderCircle className="animate-spin text-sky-600" /></span> : null}>
      <PersonalCartDrawer open={open} onClose={() => setOpen(false)} />
    </Suspense>}
  </>
}
